import React from 'react';
import PropTypes from "prop-types";
import './FormElementHeader.css';

const FormElementHeader = ({ children, id, helpDialog, required = false, ...rest }) => {

    return (
      <div className="form-element-header">
          <h3
              {...rest}
              id={id}
          >
              {children}
              {required ? <span aria-hidden="true"> *</span> : null}
        </h3>
        <div>
          {helpDialog}
        </div>
      </div>
    );
};

FormElementHeader.propTypes = {
    children: PropTypes.any,
    required: PropTypes.bool
};

export default FormElementHeader;
